export const NUMBER_PATTERN = /(\d+(?:[.,]\d+)*)/g;

export function numberAgnosticKey(text: string): string {
    return text.replace(NUMBER_PATTERN, '#');
}
